/* 🤖 this file was generated by svg-to-ts */
export const DfIconCheckmarkSquare16: {
  name: 'checkmark-square-16';
  data: string;
} = {
  name: 'checkmark-square-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.7 10.706.014-.015 3.997-4.01a.984.984 0 0 0 0-1.393.987.987 0 0 0-1.394 0L7.002 8.614 5.684 7.295a.987.987 0 0 0-1.395 0 .985.985 0 0 0 0 1.394l1.933 1.935a.987.987 0 0 0 1.477.082z"/></svg>`
};
